import React from 'react';
import VideoUpload from './VideoUpload';

function App() {
    return (
        <div className="App">
            <VideoUpload />
        </div>
    );
}

export default App;